import DataApi from './DataApi';

class SharingRuleApi extends DataApi {
  constructor() {
    super('sharingrule');
  }

  fetchAll(objectName = null, activeOnly = false) {
    const params = new URLSearchParams();
    if (objectName) params.append('objectName', objectName);
    params.append('activeOnly', activeOnly ? 'true' : 'false');
    return this.get(`?${params.toString()}`);
  }

  fetchByObject(objectName, activeOnly = false) {
    const q = new URLSearchParams();
    q.append('activeOnly', activeOnly ? 'true' : 'false');
    return this.get(`/object/${encodeURIComponent(objectName)}?${q.toString()}`);
  }

  fetchById(id) {
    return this.get(`/${id}`);
  }

  createRule(payload) {
    return this.create(payload);
  }

  updateRule(id, payload) {
    return this.put(`/${id}`, payload);
  }

  deleteRule(id) {
    return this.delete(id);
  }
}

export default SharingRuleApi;
